import { NextPage, GetServerSideProps, GetServerSidePropsResult } from 'next'
import React from 'react'
import { NextSeo } from 'next-seo'
import { envVars } from 'src/utils/env'
import { ExternalPath } from 'src/modules/path'
import { PublicGrpcClient } from '@singcolor/grpc-client'
import { GetUserOgpInfoV1Response } from '@singcolor/grpc-client/src/singcolor-proto/ts/public_v1_pb'
import { AppCustomUrlSchemeLauncher } from 'src/components/organisms/AppCustomUrlSchemeLauncher'
import { ShareLiverInfo } from 'src/components/organisms/ShareLiverInfo'

type Props = {
  userId: string
  userName: string
  userProfileImageUrl: string | undefined
}

const Page: NextPage<Props> = ({ userId, userName, userProfileImageUrl }: Props) => {
  const title = '歌配信アプリ ColorSing'
  const description = `${userName}が配信中！↓のOPENをタップしてみよう`
  const url = `${envVars.webUrl}/share/user?user_id=${userId}`

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          type: 'website',
          url,
          title,
          description,
          images: userProfileImageUrl ? [{ url: userProfileImageUrl }] : []
        }}
        twitter={{ cardType: 'summary_large_image' }}
      />
      <AppCustomUrlSchemeLauncher
        disableFallback
        customScheme={`${envVars.appCustomUrlScheme}user?user_id=${userId}`}
      />

      <ShareLiverInfo liverName={userName} liverProfileImageUrl={userProfileImageUrl} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ query }): Promise<GetServerSidePropsResult<Props>> => {
  let userId = query.user_id
  if (typeof userId !== 'string') {
    return { redirect: { statusCode: 302, destination: ExternalPath.lp } }
  }

  // grpc-webをサーバーサイドで動かすにはXMLHttpRequestをポリフィルする必要がある（無理矢理）
  global.XMLHttpRequest = require('xhr2')

  const publicGrpcClient = new PublicGrpcClient(async () => ({ 'X-SINGCOLOR-PLATFORM': 'Web(Server Side)' }))
  const userOgpInfo = await publicGrpcClient
    .getUserOgpInfo({ userId })
    .then(res => res as GetUserOgpInfoV1Response.AsObject)

  return {
    props: {
      userId,
      userName: userOgpInfo.userName,
      userProfileImageUrl: userOgpInfo.userProfileImageUrls?.large
    }
  }
}

export default Page
